module.exports = __webpack_public_path__ + "static/media/calendar.92a4ad26.svg";